import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { BRAND } from "@/lib/constants";

export default function LegalPage({ title, overline, sections }) {
  return (
    <div className="bg-white text-[#222222]" data-testid="legal-page">
      <Header />

      <section className="relative bg-[#111111] text-white pt-28 sm:pt-36 pb-14 sm:pb-20 overflow-hidden">
        <div className="absolute -top-32 right-0 w-[36rem] h-[36rem] glow-gold pointer-events-none" />
        <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
          <p
            className="overline mb-5 text-[10px] sm:text-xs"
            style={{ color: "#D4AF37" }}
          >
            <span className="inline-block w-8 sm:w-10 h-px bg-[#D4AF37] align-middle mr-3 sm:mr-4" />
            {overline}
          </p>
          <h1
            className="font-serif text-[2.25rem] sm:text-5xl lg:text-6xl text-white font-light tracking-tight leading-[1.05]"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            {title}
          </h1>
          <p className="mt-6 text-white/60 text-sm tracking-wide">
            Sidst opdateret: 1. juli 2026
          </p>
        </div>
      </section>

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="space-y-10 text-[#333333] text-base sm:text-[17px] font-light leading-relaxed">
            {sections.map((s, i) => (
              <div key={i} data-testid={`legal-section-${i}`}>
                {s.heading && (
                  <h2
                    className="font-serif text-2xl sm:text-3xl text-[#111111] font-normal mb-4 leading-snug"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    {s.heading}
                  </h2>
                )}
                {s.body.map((p, j) =>
                  Array.isArray(p) ? (
                    <ul key={j} className="list-disc pl-6 space-y-2 my-4">
                      {p.map((li, k) => (
                        <li key={k}>{li}</li>
                      ))}
                    </ul>
                  ) : (
                    <p key={j} className="mb-4">
                      {p}
                    </p>
                  )
                )}
              </div>
            ))}

            <div className="mt-16 pt-10 border-t border-black/10 text-sm text-[#555555]">
              <div className="overline mb-3">Dataansvarlig</div>
              <div className="space-y-1">
                <div className="text-[#111111] font-normal">{BRAND.legalName}</div>
                <div>CVR: {BRAND.cvr}</div>
                <div>
                  {BRAND.address.street}, {BRAND.address.city}
                </div>
                <div>
                  <a href={`mailto:${BRAND.email}`} className="link-underline">
                    {BRAND.email}
                  </a>{" "}
                  ·{" "}
                  <a href={`tel:${BRAND.phoneRaw}`} className="link-underline">
                    {BRAND.phone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
